import React from "react";
import { Dialog } from '@mui/material';
import { ReactComponent as RefusingPerson } from "../../../icons/RefusingPerson.svg";
import { texts } from "../../general/texts";
import CancelIcon from '@mui/icons-material/Cancel';
import colors from "../../colors";
import { useNavigate } from "react-router-dom";
import useMediaQuery from '@material-ui/core/useMediaQuery';

const CannotUseService = ({ isDialogOpened, handleClose }) => {
    const navigate = useNavigate()
    const isSmallScreen = useMediaQuery('(max-width:600px)');

    const redirect = () => {
        handleClose()
        navigate('/dashboard')
    }

    return (
        <Dialog
            open={isDialogOpened}
            onClose={handleClose}
            keepMounted
            fullWidth
            maxWidth="lg"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '20px',
                    width: '630px',
                    height: isSmallScreen ? '60vh' : '260px',
                    padding: '15px',
                    zIndex: 888,
                    background: '#A8CE78'
                },
            }}
        >
            <div style={{ display: 'flex', flexDirection: isSmallScreen ? 'column-reverse' : 'row', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ color: colors.white, fontSize: '28px', fontWeight: 600, marginBottom: '20px' }}>{texts['service-refused-msg']}</span>
                    <span style={{ color: colors.white, fontSize: '24px', fontWeight: 400, marginBottom: '30px' }}>{texts['service-refused']}</span>
                    <button style={{ width: '195px', height: '45px', background: colors.white, color: colors.darkBlue, border: 'none', borderRadius: '10px', fontSize: '18px', fontWeight: 700, cursor: 'pointer' }} onClick={redirect}>
                        {texts['button-do-actions']}
                    </button>
                </div>
                <RefusingPerson width={185} style={{ marginTop: '40px', marginRight: isSmallScreen ? 0 : '30px', marginLeft: isSmallScreen ? 60 : 0 }} />
                <CancelIcon onClick={handleClose} style={{ color: colors.white, width: '60px', height: '60px', cursor: 'pointer' }} />
            </div>
        </Dialog>
    )
}
export default CannotUseService;